<template>
  <layout-report :renderBackAndForthFooter="false" :isProgressDone="true" :showFooter="false">
    <v-container class="padded">
      <v-card flat>
        <v-card-title> <h1>Datenschutzerklärung</h1> </v-card-title>
        <v-card-text>
          <p class="MsoNormal">
            <span lang="DE"
              >Wir freuen uns, dass Sie unsere Web-Anwendung besuchen. Der Schutz und die Sicherheit Ihrer persönlichen
              Informationen bei der Nutzung unserer Website ist für uns sehr wichtig. Wir möchten Sie daher an dieser
              Stelle darüber informieren, welche Ihrer personenbezogenen Daten wir beim Besuch unserer Website erfassen
              und für welche Zwecke diese verwendet werden. Bei personenbezogenen Daten handelt es sich um Einzelangaben
              über persönliche oder sachliche Verhältnisse einer bestimmten oder bestimmbaren natürlichen Person
              (Betroffener), z. B. Name, Adresse, E-Mail-Adressen, Nutzerverhalten. Hierbei handelt es sich also um
              Daten, mit denen wir Sie identifizieren können. Darüber hinaus finden Sie hier vereinzelt auch
              Informationen zu Datenverarbeitungsprozessen außerhalb dieser Web-Anwendung (z. B. Videokonferenzen oder
              Newsletter).</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Verantwortlicher für die Datenverarbeitung</span></b>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Verantwortlicher</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >für die Verarbeitung personenbezogener Daten im Sinne der EU-Datenschutz-Grundverordnung (DSGVO)</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="EN-US"
              >mint future GmbH<br />
              Carl-Fischer-Str. 2 <br />
            </span>
            <span lang="DE">
              49084 Osnabrück<br />
              DE<br />
              +49 541 96328788<br />
              <a href="mailto:info@mintfuture.de">info@mintfuture.de</a></span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Datenschutzbeauftragte/r</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >exkulpa gmbh <br />
              Waldfeuchter Str. 266<br />
              52525 Heinsberg<br />
              Telefon: 02452 / 99 33 11<br />
              E-Mail: <a href="mailto:datenschutz@mintfuture.de">datenschutz@mintfuture.de</a>
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Allgemeines </span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Diese Datenschutzerklärung erfüllt die gesetzlichen Anforderungen an die Transparenz bei der Verarbeitung
              personenbezogener Daten. Dies sind alle Informationen, die sich auf eine identifizierte oder
              identifizierbare natürliche Person beziehen. Hierzu gehören beispielsweise Informationen wie Ihr Name, Ihr
              Alter, Ihre Anschrift, Ihre Telefonnummer, Ihr Geburtsdatum, Ihre E-Mail-Adresse, Ihre IP-Adresse oder das
              Nutzerverhalten beim Besuch einer Website. Informationen, bei denen wir keinen (oder nur mit einem
              unverhältnismäßigen Aufwand) Bezug zu Ihrer Person herstellen können, z. B. durch Anonymisierung, sind
              keine personenbezogenen Daten. Die Verarbeitung von personenbezogenen Daten (bspw. das Erheben, das
              Abfragen, die Verwendung, die Speicherung oder die Übermittlung) bedarf immer einer gesetzlichen Grundlage
              und eines definierten Zwecks.
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Gespeicherte personenbezogene Daten werden gelöscht, sobald der Zweck der Verarbeitung erreicht wurde und
              es keine rechtmäßigen Gründe für eine weitere Aufbewahrung der Daten gibt. Wir informieren Sie in den
              einzelnen Verarbeitungsvorgängen über die konkreten Speicherfristen bzw. Kriterien für die Speicherung.
              Unabhängig davon, speichern wir Ihre personenbezogenen Daten in Einzelfällen zur Geltendmachung, Ausübung
              oder Verteidigung von Rechtsansprüchen und bei Vorliegen gesetzlicher Aufbewahrungsfristen.
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Informationen nach Art. 13 DSGVO</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Diese Informationen richten sich an Kunden, Interessenten, Lieferanten und Mitarbeiter. Ihre
              personenbezogenen Daten werden von uns zu folgenden Zwecken verarbeitet:</span
            >
          </p>

          <ul style="margin-top: 0cm" type="square">
            <li class="MsoNormal">
              <span lang="DE"
                >Zur Erfüllung unserer vertraglichen Pflichten denen wir Ihnen gegenüber verpflichtet sind (Art. 6 Abs.
                1 lit. b DSGVO).</span
              >
            </li>
            <li class="MsoNormal">
              <span lang="DE">Zur Durchführung vorvertraglicher Pflichten (Art. 6 Abs. 1 Lit. b DSGVO).</span>
            </li>
            <li class="MsoNormal">
              <span lang="DE">Zur Beantwortung von Anfragen (Art. 6 abs. 1 Lit. b DSGVO).</span>
            </li>
            <li class="MsoNormal">
              <span lang="DE"
                >Sofern Sie uns eine Einwilligung zur Verarbeitung Ihrer personenbezogenen Daten für bestimmte Zwecke
                erteilt haben (etwa zum Empfang unseres Newsletters), findet die Datenverarbeitung auf Basis Ihrer
                Einwilligung statt (Art. 6 Abs. 1 Lit. a DSGVO).</span
              >
            </li>
            <li class="MsoNormal">
              <span lang="DE"
                >Zur Erfüllung rechtlicher Verpflichtungen, denen unser Unternehmen unterliegt (Art. 6 Abs. 1 lit. c
                DSGVO).</span
              >
            </li>
            <li class="MsoNormal">
              <span lang="DE"
                >Soweit erforderlich verarbeiten wir Ihre Daten auch zur Wahrung unserer berechtigten Interessen,
                insbesondere zur Geltendmachung rechtlicher Ansprüche und die Verteidigung bei rechtlichen
                Streitigkeiten oder die Gewährleistung der IT-Sicherheit, zur Konsultation von und dem Datenaustausch
                mit Auskunfteien zur Ermittlung von Bonitäts- und Ausfallrisiken, zur Direktwerbung und Marktforschung
                soweit Sie der Nutzung Ihrer Daten zu diesem Zweck nicht widersprochen haben, bei Maßnahmen zur
                Geschäftssteuerung und Weiterentwicklung von Dienstleistungen und Produkten, bei Maßnahmen zur Produkt-
                und Vertriebsoptimierung, bei Maßnahmen zur Risikosteuerung, zur Verhinderung oder Aufklärung von
                Straftaten (Art. 6 Abs. 1 Lit. f DSGVO).</span
              >
            </li>
          </ul>

          <p class="MsoNormal">
            <b><span lang="DE">Kategorien von Empfängern der personenbezogenen Daten</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Innerhalb unseres Unternehmens haben nur diejenigen Mitarbeiter Zugriff auf die Daten, die diese
              unbedingt zur Erfüllung Ihrer Aufgaben benötigen (need-to-know-Prinzip). Einzelne Prozesse und
              Serviceleistungen werden durch sorgfältig ausgewählte und datenschutzkonform beauftragte Dienstleister
              ausgeführt, die Ihren Sitz innerhalb des EWR haben. Sofern von uns beauftragte Dienstleister bei der
              Durchführung Ihrer Leistungen Zugriff auf personenbezogene Daten erhalten, wurden mit diesen
              Auftragsverarbeitungsverträge nach Art. 28 Abs. 3 DSGVO geschlossen.
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Dauer der Datenspeicherung</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Die von uns verarbeiteten Daten werden für die Dauer des Bestehens und der Abwicklung des
              Vertragsverhältnisses sowie unter Einhaltung von gesetzlichen Aufbewahrungsfristen gespeichert. Dies sind
              insbesondere handels- und steuerrechtliche Aufbewahrungspflichten nach dem Handelsgesetzbuch (HGB) und die
              Abgabenordnung (AO). Die regelmäßigen Aufbewahrungs- bzw. Dokumentationsfristen belaufen sich hiernach auf
              bis zu zehn Jahre. Kommt es zu keinem Vertragsverhältnis, verarbeiten wir die Daten nur so lange, wie es
              der konkrete Zweck erfordert.</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Ihre Betroffenenrechte</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Als Betroffener haben Sie folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten
              gegenüber uns:</span
            >
          </p>

          <ul style="margin-top: 0cm" type="square">
            <li class="MsoNormal">
              <span lang="DE">Recht auf Auskunft über die zu Ihrer Person bei uns verarbeiteten Daten.</span>
            </li>
            <li class="MsoNormal">
              <span lang="DE"
                >Recht auf Berichtigung oder Löschung, sofern diese falsch, nicht aktuell oder unrechtmäßig von uns
                erhoben worden sind.</span
              >
            </li>
            <li class="MsoNormal">
              <span lang="DE"
                >Recht auf Einschränkung der Verarbeitung, sofern eine vollständige Löschung nicht möglich ist, z.B.
                weil wir gesetzliche Aufbewahrungspflichten zu wahren haben.</span
              >
            </li>
            <li class="MsoNormal">
              <span lang="DE"
                >Recht auf Widerspruch gegen die Verarbeitung, sofern sich die Datenverarbeitung auf eine
                Interessenabwägung (das sogenannte berechtigte Interesse) stützt, wie oben unter „Zweck der
                Verarbeitung“ beschrieben. Dies ist der Fall, wenn die Verarbeitung insbesondere nicht zur Erfüllung
                eines Vertrages mit Ihnen erforderlich ist. Bei Geltendmachung Ihres Widerspruchsrechts bitten wir um
                Darlegung der Gründe, weshalb wir Ihre Daten nicht wie von uns durchgeführt verarbeiten sollten.</span
              >
            </li>
          </ul>

          <p class="MsoNormal">
            <span lang="DE"
              >Selbstverständlich können Sie auch der Verarbeitung Ihrer personenbezogenen Daten für Zwecke der Werbung
              jederzeit widersprechen. Richten Sie Ihren Widerspruch hierzu an unsere im Impressum angegebene Adresse
              oder schreiben Sie uns eine E-Mail an die im Impressum angegebene Adresse.</span
            >
          </p>

          <ul style="margin-top: 0cm" type="square">
            <li class="MsoNormal">
              <span lang="DE"
                >Recht auf Widerruf, sofern Sie uns eine Einwilligung zur Verarbeitung Ihrer Daten erteilt haben. Ihren
                Widerruf können Sie jederzeit ohne Angabe von Gründen gegenüber unserem Unternehmen geltend machen.
                Wenden Sie sich hierzu bitte an die im Impressum angegebene Adresse.</span
              >
            </li>
            <li class="MsoNormal">
              <span lang="DE"
                >Darüber hinaus haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung
                Ihrer personenbezogenen Daten durch unser Unternehmen zu beschweren.</span
              >
            </li>
          </ul>

          <p class="MsoNormal">
            <span lang="DE"
              >Bei Fragen zum Datenschutz können Sie sich gerne per E-Mail an die im Impressum angegebene Adresse
              wenden.</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Cookies</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Cookies sind kleine Textdateien, die im Rahmen Ihres Besuchs unserer Internetseiten von uns an den
              Browser Ihres Endgeräts gesendet und dort gespeichert werden. Alternativ zum Einsatz von Cookies können
              Informationen auch im lokalen Speicher (local storage) Ihres Browsers gespeichert werden. Einige
              Funktionen unserer Internetseite können ohne den Einsatz von Cookies bzw. local storage nicht angeboten
              werden (technisch notwendige Cookies). Andere Cookies ermöglichen uns hingegen verschiedene Analysen,
              sodass wir beispielsweise in der Lage sind, den von Ihnen verwendeten Browser bei einem erneuten Besuch
              unserer Webseite wiederzuerkennen und verschiedene Informationen an uns zu übermitteln (nicht notwendige
              Cookies). Mithilfe von Cookies können wir unter anderem unser Internetangebot für Sie nutzerfreundlicher
              und effektiver gestalten, indem wir etwa Ihre Nutzung unserer Website nachvollziehen und Ihre bevorzugten
              Einstellungen (bspw. Länder- und Spracheneinstellungen) feststellen. Sofern Dritte über Cookies
              Informationen verarbeiten, erheben diese die Informationen direkt über Ihren Browser. Cookies richten auf
              Ihrem Endgerät keinen Schaden an. Sie können keine Programme ausführen und keine Viren enthalten.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Über die jeweiligen Dienste, für die wir Cookies einsetzen, informieren wir in den einzelnen
              Verarbeitungsvorgängen. Ausführliche Informationen zu den eingesetzten Cookies finden Sie in den
              Cookie-Einstellungen oder im Consent Manager dieser Website.</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Ihre Rechte </span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Unter den Voraussetzungen der gesetzlichen Vorschriften der Datenschutz-Grundverordnung (DSGVO) haben Sie
              als betroffene Person folgende Rechte:</span
            >
          </p>

          <ul style="margin-top: 0cm" type="square">
            <li class="MsoNormal">
              <b><span lang="DE">Auskunft</span></b
              ><span lang="DE">
                gem. Art. 15 DSGVO über die zu Ihrer Person gespeicherten Daten in Form von aussagekräftigen
                Informationen zu den Einzelheiten der Verarbeitung sowie eine Kopie Ihrer Daten;</span
              >
            </li>
            <li class="MsoNormal">
              <b><span lang="DE">Berichtigung</span></b
              ><span lang="DE">
                gem. Art. 16 DSGVO von unrichtigen oder unvollständigen Daten, die bei uns gespeichert sind;</span
              >
            </li>
            <li class="MsoNormal">
              <b><span lang="DE">Löschung</span></b
              ><span lang="DE">
                gem. Art. 17 DSGVO der bei uns gespeicherten Daten, soweit die Verarbeitung nicht zur Ausübung des
                Rechts auf freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen Verpflichtung, aus
                Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder Verteidigung von
                Rechtsansprüchen erforderlich ist;</span
              >
            </li>
            <li class="MsoNormal">
              <b><span lang="DE">Einschränkung</span></b
              ><span lang="DE">
                der Verarbeitung gem. Art. 18 DSGVO, soweit die Richtigkeit der Daten bestritten wird, die Verarbeitung
                unrechtmäßig ist, wir die Daten nicht mehr benötigen und Sie deren Löschung ablehnen, weil Sie diese zur
                Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie Widerspruch gegen die
                Verarbeitung gem. Art. 21 DSGVO erhoben haben.</span
              >
            </li>
            <li class="MsoNormal">
              <b><span lang="DE">Datenübertragbarkeit</span></b
              ><span lang="DE">
                gem. Art. 20 DSGVO, soweit Sie uns personenbezogene Daten im Rahmen einer Einwilligung gem. Art. 6 Abs.
                1 lit. a DSGVO oder auf Grundlage eines Vertrages gem. Art. 6 Abs. 1 lit. b DSGVO bereitgestellt haben
                und diese durch uns mithilfe automatisierter Verfahren verarbeitet wurden. Sie erhalten Ihre Daten in
                einem strukturierten, gängigen und maschinenlesbaren Format bzw. wir übermitteln die Daten direkt an
                einen anderen Verantwortlichen, soweit dies technisch machbar ist.</span
              >
            </li>
            <li class="MsoNormal">
              <b><span lang="DE">Widerspruch</span></b
              ><span lang="DE">
                gem. Art. 21 DSGVO gegen die Verarbeitung Ihrer personenbezogenen Daten, soweit diese auf Grundlage des
                Art. 6 Abs. 1 lit. e, f DSGVO erfolgt und dafür Gründe vorliegen, die sich aus Ihrer besonderen
                Situation ergeben oder sich der Widerspruch gegen Direktwerbung richtet. Das Recht auf Widerspruch
                besteht nicht, wenn überwiegende, zwingende schutzwürdige Gründe für die Verarbeitung nachgewiesen
                werden oder die Verarbeitung zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen
                erfolgt. Soweit das Recht auf Widerspruch bei einzelnen Verarbeitungsvorgängen nicht besteht, ist dies
                dort angegeben.</span
              >
            </li>
            <li class="MsoNormal">
              <b><span lang="DE">Widerruf</span></b
              ><span lang="DE">
                gem. Art. 7 Abs. 3 DSGVO Ihrer erteilten Einwilligung mit Wirkung für die Zukunft.</span
              >
            </li>
            <li class="MsoNormal">
              <b><span lang="DE">Beschwerde</span></b
              ><span lang="DE">
                gem. Art. 77 DSGVO bei einer Aufsichtsbehörde, wenn Sie der Ansicht sind, die Verarbeitung Ihrer
                personenbezogenen Daten verstößt gegen die DSGVO. In der Regel können Sie sich an die Aufsichtsbehörde
                Ihres üblichen Aufenthaltsortes, Ihres Arbeitsplatzes oder unseres Unternehmenssitzes wenden.</span
              >
            </li>
          </ul>

          <p class="MsoNormal">
            <b><span lang="DE">Datenverarbeitung durch unsere Web-Anwendung </span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Nachfolgend informieren wir Sie über die einzelnen Verarbeitungsvorgänge, den Umfang und den Zweck der
              Datenverarbeitung, die Rechtsgrundlage, die Pflicht zur Bereitstellung Ihrer Daten und die jeweilige
              Speicherdauer. Eine automatisierte Entscheidung im Einzelfall, einschließlich Profiling findet nicht
              statt.</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Anfrage innerhalb der Web-Anwendung, per E-Mail oder Telefon</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wenn Sie uns kontaktieren (z. B. via Kontaktformular innerhalb der Web-Anwendung, per E-Mail oder
              Telefon), wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (z. B. Name,
              Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
              mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf Ihrer Einwilligung (Art. 6 Abs. 1
              lit. A DSGVO) und/oder auf unseren berechtigten Interessen (Art. 6 Abs. 1 lit. f DSGVO), da wir ein
              berechtigtes Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen haben.
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Die von Ihnen an uns per Kontaktanfrage übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
              auffordern, Ihre Einwilligung zur Speicherung widerrufen oder Zweck für die Datenspeicherung entfällt (z.
              B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere
              gesetzliche Aufbewahrungsfristen – bleiben unberührt.
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Registrierung eines Benutzerkontos</span></b>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Art und Umfang der Verarbeitung</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Für die Nutzung bestimmter Bereiche unserer Website haben Sie die Möglichkeit ein Benutzerkonto zu
              registrieren. Die Informationen, die während der Registrierung über die Pflichtfelder erhoben werden, sind
              für die Bereitstellung eines Zugangs zum Benutzerkonto erforderlich. Darüber hinaus können Sie freiwillig
              zusätzliche Informationen für ergänzende (Komfort-)Funktionen bereitstellen.</span
            >
          </p>
          <p class="MsoNormal">
            <span lang="DE"
              >Für die Registrierung eines Benutzerkontos erfolgt die Weitergabe Ihrer personenbezogenen Daten
              ausschließlich gemäß dieser Datenschutzerklärung.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE">
              Wir geben deine Daten nur an Dritte weiter, wenn wir hierzu aufgrund deiner Einwilligung berechtigt oder
              aufgrund des geltenden Rechts berechtigt oder verpflichtet sind (dies schließt auch eine Übermittlung der
              Daten an das Umweltbundesamt und andere möglicherweise zuständige Behörden zur Geltendmachung der
              THG-Quote ein). Gleiches gilt, wenn wir deine Daten von Dritten, d.h. weder von euch noch von uns
              beauftragten Unternehmen, erhalten.

              <br />
              <br />

              <span lang="DE" v-if="isDatasharingActive" ref="isDatasharingActive">
                Sofern du hierzu deine Zustimmung erteilt hast, geben wir deine Daten insbesondere an unseren Partner,
                {{ companyName }}, {{ street }}, {{ zip }} {{ city }}, weiter. Soweit der Vertrag auf der Grundlage
                eines Vermittlers zustande gekommen ist, werden mit diesem nur die notwendigen Daten zur
                Provisionsabrechnung ausgetauscht</span
              >
              <br v-if="isDatasharingActive" />
              <br v-if="isDatasharingActive" />

              Neben den in diesen Datenschutzhinweisen ausdrücklich genannten Dritten können gegebenenfalls auch externe
              Dienstleister für den Betrieb unserer Website im Rahmen von Auftragsverarbeitungsverträgen, Staatliche
              Stellen und Behörden, soweit dies zur Erfüllung einer gesetzlichen Verpflichtung erforderlich ist, oder
              zur Durchführung unseres Geschäftsbetriebs eingesetzte Personen (wie z.B. Auditoren, Rechtsberater,
              Versicherungen, Banken, Aufsichtsbehörden) Zugriff auf deine Daten erhalten.

              <br />
              <br />

              Soweit externe Dienstleister mit Deinen personenbezogenen Daten in Berührung kommen, stellen wir durch
              rechtliche, technische und organisatorische Maßnahmen sicher, dass diese die Vorschriften der
              Datenschutzgesetze einhalten und – soweit sie als Auftragsverarbeiter tätig werden – deine Daten nur in
              unserem Auftrag und nach unseren Weisungen verarbeiten.
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Zweck und Rechtsgrundlage</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wir verarbeiten Ihre Daten zum Zweck der Bereitstellung eines Benutzerkontos zur Erfüllung eines Vertrags
              mit Ihnen gem. Art. 6 Abs. 1 lit. b DSGVO. Es besteht eine vertragliche Pflicht zur Bereitstellung Ihrer
              Daten, da diese Informationen zur Identifizierung Ihrer Person sowie zur Vertragserfüllung unsererseits
              erforderlich sind. Eine gesetzliche Pflicht zur Bereitstellung der Daten besteht nicht. Ohne die
              Bereitstellung dieser Informationen ist die Registrierung eines Benutzerkontos und somit ein
              Vertragsschluss nicht möglich.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Darüber hinaus erfolgt die Verarbeitung zusätzlich freiwillig angegebener Informationen zum Zweck der
              Bereitstellung weiterer (Komfort-)Funktionen auf Grundlage Ihrer Einwilligung gem. Art. 6 Abs. 1 lit. a
              DSGVO. Durch die Deaktivierung der Funktionen / Durch die Löschung der freiwilligen Angaben im
              Benutzerkonto können Sie jederzeit mit Wirkung für die Zukunft Ihren Widerruf gem. Art. 7 Abs. 3 DSGVO
              erklären.</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Speicherdauer</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wir speichern Ihre personenbezogenen Daten im Rahmen der Bereitstellung des Benutzerkontos für die Dauer
              des Vertragsverhältnisses. Nach Ende des Vertrages / Löschen des Benutzerkontos erfolgt eine weitere
              Speicherung Ihrer Daten nur, sofern gesetzliche Aufbewahrungspflichten (z.B. Steuer- und Handelsrecht)
              bestehen.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Zusätzliche Informationen, die Sie uns auf Grundlage Ihrer Einwilligung bereitstellen, werden nur so
              lange gespeichert, bis Sie Ihre Einwilligung durch Deaktivierung der Funktionen / durch Löschen der Daten
              widerrufen, längstens jedoch bis zum Ende des Vertrages, dem die Bereitstellung des Benutzerkontos
              zugrunde liegt.</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Erfassung personenbezogener Daten im Rahmen der App-Nutzung</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE">Wenn Sie unsere App nutzen, erfassen wir folgende personenbezogene Daten von Ihnen: </span>
          </p>

          <p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Vor- und Nachname</span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">E-Mail-Adresse</span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Anschrift</span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Ggf. Steuernummer</span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Angaben zum Fahrzeug </span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Nutzungsdaten </span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">IP-Adresse</span>
          </p>

          <p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Metadaten </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Die Verarbeitung dieser personenbezogenen Daten ist erforderlich, um die Funktionalität der App-Anwendung
              zu gewährleisten. Rechtsgrundlage für diese Datenverarbeitung ist unser berechtigtes Interesse im Sinne
              von Art. 6 Abs. 1 lit. f DS-GVO, Ihre Einwilligung im Sinne des Art. 6 Abs. 1 lit. a DS-GVO und/oder –
              sofern ein Vertrag geschlossen wurde – die Erfüllung unserer vertraglichen Verpflichtungen (Art. 6 Abs. 1
              lit. b DS-GVO).
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">mint software GmbH</span></b
            ><span lang="DE"> (<a href="http://www.mmmint.ai">www.mmmint.ai</a>) </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Bei Aufruf und Nutzung unserer Web-Anwendung erheben wir die personenbezogenen Daten, die Ihre Browser
              automatisch an unseren Server übermittelt. Die folgenden Informationen werden temporär in einem sog.
              Logfile gespeichert:
            </span>
          </p>

          <p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">IP-Adresse des anfragenden Rechners </span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Datum und Uhrzeit des Zugriffs</span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Name und URL der abgerufenen Datei </span>
          </p>

          <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE">Webseite, von der aus der Zugriff erfolgt (Referrer-URL)</span>
          </p>

          <p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
            <span lang="DE" style="font-family: Symbol"
              >·<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
            ><span lang="DE"
              >Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners, sowie der Name Ihres
              Access-Providers</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Unsere Web-Anwendung wird nicht von uns selbst gehostet, sondern bei einem Dienstleister, der für den
              Zweck der Bereitstellung der Webseite die zuvor genannten Daten in unserem Auftrag gem. Art. 28 DSGVO
              verarbeitet.
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und
              bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten
              Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f
              DSGVO).</span
            >
          </p>

          <p class="MsoNormal"><span lang="DE">Wir setzen folgenden Dienstleister ein: </span></p>

          <p class="MsoNormal">
            <span lang="DE">
              mint software GmbH<br />
              Carl-Fischer-Str. 2<br />
              49084 Osnabrück</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Microsoft Azure CDN</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wir nutzen das Content Delivery Network Microsoft Azure CDN. Anbieter ist die Microsoft Corporation, One
              Microsoft Way, Redmond, WA 98052-6399, USA.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Ein CDN ermöglicht uns die schnelle Auslieferung einiger Inhalte, insbesondere geht es hierbei um große
              Mediendateien. Dies geschieht über ein Netz aus regional verteilten Servern, die über das Internet
              verbunden sind. Der Anbieter kann auf diese Weise die Datenübermittlung zwischen Ihrem Browser und unseren
              Servern analysieren und potenziell bösartigen Datenverkehr filtern. Die Verarbeitung der Daten der Nutzer
              erfolgt allein zu den vorgenannten Zwecken und dient der Aufrechterhaltung der Sicherheit und
              Funktionsfähigkeit des CDN.
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Der Einsatz von Microsoft Azure CDN beruht auf unserem berechtigten Interesse an einer möglichst
              fehlerfreien und sicheren Bereitstellung unseres Webangebotes (Art. 6 Abs. 1 lit. f DS-GVO).
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt. Details
              finden Sie hier:
              <a href="https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses"
                ><span style="color: blue"
                  >https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses</span
                ></a
              ></span
            ><span lang="DE">.</span>
          </p>

          <p class="MsoNormal">
            <span lang="DE">Weitere Informationen zu Microsoft Azure CDN finden Sie hier: </span
            ><span lang="DE"
              ><a href="https://azure.microsoft.com/de-de/products/cdn/#overview"
                ><span style="color: blue">https://azure.microsoft.com/de-de/products/cdn/#overview</span></a
              ></span
            ><span lang="DE">.</span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Auftragsverarbeitung </span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Um sicherzustellen, dass personenbezogene Daten nach unseren Vorgaben und unter Einhaltung der DS-GVO
              verarbeitet werden, haben wir einen Vertrag über Auftragsverarbeitung (AVV) mit dem Anbieter geschlossen.
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Datenanalyse</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wenn Sie auf unsere App zugreifen, kann Ihre Verhalten mit Hilfe bestimmter Analyse-Werkzeuge statistisch
              ausgewertet und zu Werbe- und Marktforschungszwecken oder zur Verbesserung unserer Angebote analysiert
              werden. Bei der Verwendung derartiger Tools achten wir auf die Einhaltung der gesetzlichen
              Datenschutzbestimmungen. Beim Einsatz externer Dienstleister (Auftragsverarbeiter) stellen wir durch
              entsprechende Verträge mit den Dienstleistern sicher, dass die Datenverarbeitung den deutschen und
              europäischen Datenschutzstandards entspricht.
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Microsoft Application Insights </span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wir nutzen Microsoft Application Insights, ein Dienst von Azure Monitor. Anbieter ist die Microsoft
              Corporation, One Microsoft Way, Redmond, WA 98052-6399, USA.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Application Insights hilft uns bei der Optimierung der Leistung und Benutzerfreundlichkeit unserer
              Web-Anwendung, indem der Dienst beispielsweise Aufschluss darüber gibt, zu welchen Tageszeiten die
              Anwendung am meisten besucht wird, wie gut die Anwendung reagiert oder wo mögliche Fehler- und
              Problemquellen liegen. Hierzu werden Telemetriedaten (wie die URL oder die IP-Adresse) erhoben und
              verarbeitet.
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Bei der Nutzung von Microsoft Application Insights stützen wir uns auf Art. 6 Abs. 1 lit. f DS-GVO als
              rechtliche Grundlage für die Speicherung und die Analyse von personenbezogenen Daten, da wir ein
              berechtigtes Interesse daran haben, die Nutzung unserer App zu analysieren. Dadurch können wir unsere
              Onlinepräsenz und unsere Angebote für Sie optimieren. Wenn Sie zuvor eine Einwilligung zur
              Datenverarbeitung auf dieser Website durch Application Insights abgegeben haben, findet die Verarbeitung
              Ihrer Daten auf der rechtlichen Grundlage von Art. 6 Abs. 1 lit. a DS-GVO statt. Sie können Ihre
              Einwilligung jederzeit widerrufen.
            </span>
          </p>

          <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal">
            <span lang="DE"
              >Die Übertragung Ihrer personenbezogenen Daten in die USA wird auf die Standardvertragsklauseln der
              EU-Kommission gestützt. Nähere Informationen hierzu finden Sie hier:
              <a href="https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses"
                ><span style="color: blue"
                  >https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses</span
                ></a
              ></span
            ><span lang="DE">.</span>
          </p>

          <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal"><span lang="DE">&nbsp;</span></p>

          <p class="MsoNormal">
            <span lang="DE"
              >Weitere Informationen zur Datenverarbeitung durch Microsoft Application Insights bzw. zu Azure Monitor
              finden Sie hier:
              <a href="https://learn.microsoft.com/de-de/azure/azure-monitor/app/data-retention-privacy"
                ><span style="color: blue"
                  >https://learn.microsoft.com/de-de/azure/azure-monitor/app/data-retention-privacy</span
                ></a
              ></span
            ><span lang="DE">.</span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Google Tag Manager</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wir nutzen auf dieser Website Dienste und Funktionen vom Google Tag Manager, die von der Google Ireland
              Limited, Gordon House, Barrow Street, Dublin 4, Irland angeboten werden.
            </span>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Der Google Tag Manager ist ein Tool, mit dessen Hilfe wir andere Tools auf unserer Website einsetzen
              können. Er erstellt keine Benutzerprofile, er speichert keine Cookies und er führt keine unabhängigen
              Analysen durch. Allerdings wird Ihre IP-Adresse erfasst und gegebenenfalls in die USA übermittelt. Der
              Google Tag Manager selbst wird nur für die Verwaltung dieser Tools verwendet, die über ihn integriert
              sind.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Beim Einsatz des Google Tag Managers auf dieser Website stützen wir uns auf Art. 6 Abs. 1 lit. f DSGVO
              als rechtliche Grundlage, da wir ein berechtigtes Interesse daran haben, Tracking-Tools auf dieser Website
              einfach und schnell zu implementieren und zu lenken. Wenn Sie zuvor eine Einwilligung zur
              Datenverarbeitung auf dieser Website durch den Google Tag Manager abgegeben haben, findet die Verarbeitung
              Ihrer Daten allein auf der rechtlichen Grundlage von Art. 6 Abs. 1 lit. a DSGVO § 25 Abs. 1 TTDSG statt.
              Sie können Ihre Einwilligung jederzeit widerrufen.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Das Unternehmen ist nach dem &quot;EU-US Data Privacy Framework&quot; (DPF) zertifiziert, ein Abkommen
              zwischen der Europäischen Union und den USA, welches darauf abzielt, die Einhaltung europäischer
              Datenschutzstandards bei der Datenverarbeitung in den USA zu sichern. Die Zertifizierung nach dem DPF
              verpflichtet Unternehmen, diese Datenschutzstandards zu beachten. Nähere Informationen erhalten Sie
              unter:&nbsp;<a
                href="https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&amp;id=a2zt000000001L5AAI&amp;status=Active"
                target="_blank"
                >https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&amp;id=a2zt000000001L5AAI&amp;status=Active</a
              ></span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Google Ads</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wir nutzen auf dieser Website Dienste und Funktionen von Google Ads, die von der Google Ireland Limited,
              Gordon House, Barrow Street, Dublin 4, Irland angeboten werden.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Mit Hilfe von Google Ads können wir Online-Werbeanzeigen in der Google-Suchmaschine oder auf anderen
              Websites anzeigen lassen, wenn Nutzer nach bestimmten Begriffen suchen. Darüber hinaus können Anzeigen auf
              Grundlage von Nutzerdaten für bestimmte Zielgruppen geschaltet werden. Die Anzeigen sind beispielsweise
              auf die Interessen und den Standort der Nutzer ausgerichtet. Wir werten diese Nutzerdaten und die Anzahl
              der Klicks aus, um den Erfolg unserer Werbeanzeigen messen zu können.</span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Rechtsgrundlagen</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Bei der Nutzung von Google Ads stützen wir uns auf Art. 6 Abs. 1 lit. f DSGVO als rechtliche Grundlage,
              da wir ein berechtigtes Interesse daran haben, die Nutzung unserer Website zu analysieren, um unsere
              Dienstleistungen und Produkte erfolgreich zu vermarkten.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Die Übertragung Ihrer personenbezogenen Daten in die USA wird auf die Standardvertragsklauseln der
              EU-Kommission gestützt. Nähere Informationen hierzu finden Sie unter&nbsp;<a
                href="https://policies.google.com/privacy/frameworks"
                target="_blank"
                >https://policies.google.com/privacy/frameworks</a
              >&nbsp;und<br />
              <a href="https://privacy.google.com/businesses/controllerterms/mccs/" target="_blank"
                >https://privacy.google.com/businesses/controllerterms/mccs/</a
              >.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Das Unternehmen ist nach dem &quot;EU-US Data Privacy Framework&quot; (DPF) zertifiziert, ein Abkommen
              zwischen der Europäischen Union und den USA, welches darauf abzielt, die Einhaltung europäischer
              Datenschutzstandards bei der Datenverarbeitung in den USA zu sichern. Die Zertifizierung nach dem DPF
              verpflichtet Unternehmen, diese Datenschutzstandards zu beachten. Nähere Informationen erhalten Sie
              unter:&nbsp;<a
                href="https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&amp;id=a2zt000000001L5AAI&amp;status=Active"
                target="_blank"
                >https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&amp;id=a2zt000000001L5AAI&amp;status=Active</a
              ></span
            >
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Erweiterte Conversions</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wir nutzen auf unserer Website die Funktionen der Erweiterten Conversions mit Google Ads.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Wenn Sie auf unserer Website eine Conversion durchführen, erheben wir Ihre personenbezogenen Daten wie
              Ihre E-Mail-Adresse, Ihren Name, Ihre Wohnanschrift oder Ihre Telefonnummer, die Sie auf unserer Website
              eingeben. Diese Informationen können mittels der Erweiterten Conversion in Conversion-Tracking-Tags
              aufgezeichnet, gehasht und in Form von Hash-Daten an Google weitergeleitet werden, um die Messung von
              Conversions auf unserer Website zu optimieren.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Der Einsatz der Erweiterten Conversions erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit.
              a DSGVO in Verbindung mit §25 Abs. 1 TTDSG statt. Sie können Ihre Einwilligung jederzeit widerrufen.</span
            >
          </p>

          <p class="MsoNormal">
            <span lang="DE"
              >Mehr Informationen zu der Funktionsweise der Erweiterten Conversions finden Sie hier:
              <a href="https://support.google.com/google-ads/answer/9888656?hl=de" target="_blank"
                >https://support.google.com/google-ads/answer/9888656?hl=de</a
              ></span
            >
          </p>
        </v-card-text>
      </v-card>
    </v-container>
  </layout-report>
</template>

<script lang="ts">
import LayoutReport from "@/layouts/LayoutReport.vue";
import { PartnerEntity } from "@/models/partnerEntity";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { LayoutReport }
})
export default class ThgPrivacy extends Vue {
  get partner(): PartnerEntity {
    return ReportModule?.partner;
  }

  get isDatasharingActive(): boolean {
    return !!this.partner?.settings?.isDatasharingActive;
  }

  get companyName(): string {
    return this.partner?.companyName;
  }

  get street(): string {
    return this.partner?.address?.street || "";
  }

  get city(): string {
    return this.partner?.address?.city || "";
  }

  get zip(): string {
    return this.partner?.address?.zip || "";
  }
}
</script>

<style scoped>
.contain {
  width: 100%;
  padding: 1em;
}
</style>
